/*
  Contact page for FullStack.cash
*/

import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Container, Row, Col } from 'react-bootstrap'
import ContactForm from '../components/ContactForm'

function Contact () {
  return (
    <>
      <Helmet>
        <title>Contact Us - FullStack.cash</title>
        <meta name='contact' content='Contact FullStack.cash' />
      </Helmet>

      <Container className='py-5'>
        <Row>
          <Col>
            <h1>Contact Us</h1>
            <p>
              <strong>
                Fill out the form below to send an email to the organization
                running this website.
              </strong>
            </p>
            <h4>
              <strong>
                You can also reach the community by
                joining <a href='https://t.me/bch_js_toolkit' target='_blank' rel='noreferrer'>this Telegram channel</a>.
              </strong>
            </h4>
            <ContactForm />
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Contact
